import { BellRing, Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { promptModal } from '@/components/ui/modal'
import { useRemindEmployee, useReminderHistory } from '@/features/hr/belgeler/followupApi'
import { fmtDateTime } from '@/features/shared/format'
import { apiErrorMessage } from '@/i18n'
import { SectionCard } from './SectionCard'

/** Eksik belge takibi: elle hatırlatma (personel + yöneticisi, günde bir) ve hatırlatma geçmişi. */
export function BelgeTakipCard({ personelId, eksik }: { personelId: string; eksik: number }) {
  const { t } = useTranslation()
  const history = useReminderHistory(personelId, true)
  const remind = useRemindEmployee()
  const onRemind = async () => {
    const note = await promptModal({ title: t('hr.belgeler.remind.title'), description: t('hr.belgeler.remind.hint'), placeholder: t('hr.belgeler.remind.notePlaceholder'), confirmLabel: t('hr.belgeler.remind.send') })
    if (note == null) return
    remind.mutate(
      { employeeId: personelId, note: note.trim() },
      { onSuccess: (r) => toast.success(t('hr.belgeler.remind.sent', { count: Number(r?.sent) || 0 })), onError: (e) => toast.error(apiErrorMessage(e)) },
    )
  }
  const rows = history.data ?? []
  return (
    <SectionCard title={t('hr.belgeler.remind.cardTitle')}>
      <div className="space-y-3">
        <Button size="sm" variant="outline" className="w-full" disabled={!eksik || remind.isPending} onClick={() => void onRemind()}>
          {remind.isPending ? <Loader2 className="animate-spin" /> : <BellRing />}
          {t('hr.belgeler.remind.button')}
        </Button>
        <p className="text-xs text-muted-foreground">{t('hr.belgeler.remind.auto')}</p>
        {rows.length ? (
          <ul className="space-y-2 text-xs">
            {rows.slice(0, 6).map((r, i) => (
              <li key={i} className="border-l-2 border-primary/30 pl-2">
                <p className="font-medium">
                  {t(`hr.belgeler.remind.kind.${r.kind}`)} → {r.recipient || '—'}
                </p>
                <p className="text-muted-foreground">
                  {fmtDateTime(r.at)}
                  {r.sentBy ? ` · ${r.sentBy}` : ''}
                  {r.note ? ` · ${r.note}` : ''}
                </p>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-xs text-muted-foreground">{t('hr.belgeler.remind.none')}</p>
        )}
      </div>
    </SectionCard>
  )
}
